import React, { useState } from 'react'
import styled from 'styled-components'
import CountUp from 'react-countup'
import ScrollTrigger from 'react-scroll-trigger'

const History = () => {
    const [counterOn, setCounterOn] = useState(false)
  return (
    <>
      <Wrapper>
        <div className="container">
           <div className="rating">
            <div className="box">
                <div className="image">
                    <img src="./Images/happyClient.png" alt="" width={30}/>
                </div>
                <ScrollTrigger onEnter={()=>setCounterOn(true)} onExit={()=>setCounterOn(false)}>
                <div className="number">
                    <h1>
                        {
                            counterOn?<CountUp className='countUp' start={0} end={50} duration={5} delay={0}  style={{fontSize:"35px", color:"rgba(255, 204, 0, 1)"}}/>:""
                        }
                       
                    </h1>
                </div>
                </ScrollTrigger>
                <div className="details">
                    <p>Happy Clients</p>
                </div>
            </div>

            <div className="box">
                <div className="image">
                    <img src="./Images/projectCompleted.png" alt="" width={30}/>
                </div>
                <ScrollTrigger onEnter={()=>setCounterOn(true)} onExit={()=>setCounterOn(false)}>
                <div className="number">
                    <h1>
                        {
                            counterOn?<CountUp start={0} end={50} duration={5} delay={0}  style={{fontSize:"35px", color:"rgba(255, 204, 0, 1)"}}/>:""
                        }
                       
                    </h1>
                </div>
                </ScrollTrigger>
                <div className="details">
                    <p>Project Completed</p>
                </div>
            </div>

            <div className="box">
                <div className="image">
                    <img src="./Images/rating.png" alt="" width={30}/>
                </div>
                <ScrollTrigger onEnter={()=>setCounterOn(true)} onExit={()=>setCounterOn(false)}>
                <div className="number">
                    <h1>
                        {
                            counterOn?<CountUp start={0} end={5} duration={5} delay={0}  style={{fontSize:"35px", color:"rgba(255, 204, 0, 1)"}}/>:""
                        }
                       
                    </h1>
                </div>
                </ScrollTrigger>
                <div className="details">
                    <p>Rating</p>
                </div>
            </div>

            <div className="box">
                <div className="image">
                    <img src="./Images/filesDownload.png" alt="" width={30}/>
                </div>
                <ScrollTrigger onEnter={()=>setCounterOn(true)} onExit={()=>setCounterOn(false)}>
                <div className="number">
                    <h1>
                        {
                            counterOn?<CountUp start={0} end={100} duration={5} delay={0}  style={{fontSize:"35px", color:"rgba(255, 204, 0, 1)"}}/>:""
                        }
                       
                    </h1>
                </div>
                </ScrollTrigger>
                <div className="details">
                    <p>Files Download</p>
                </div>
            </div>
           </div>
        </div>
        <div className="line"></div>
      </Wrapper>
    </>
  )
}

export default History

const Wrapper = styled.section`
.container{
    width: 100%;
    height: auto;
    background-image:url("./Images/history.png");
    background-position: center;
    background-size: cover;
    /* background-attachment: fixed; */
    padding-left: 10%;
    padding-right: 10%;
   
}
.rating{
    width: 100%;
    height: auto;
    display: flex;
    align-items: center;
    justify-content: space-around;
    flex-direction: row;
    flex-wrap: wrap;
    padding-top: 100px;
    padding-bottom: 100px;
}
.box{
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-direction: column;
}
.number{
    font-size: 35px;
    color: rgba(255, 204, 0, 1);
}
.line{
    width: 100%;
    height: 1px;
    background-color:  rgba(67, 67, 67, 1);
}
@media (max-width: 768px) {
    .box{
        width: 50%;
        margin-top: 20px;
    }
    .number h1{
        font-size: 25px;
    }
    .details p{
        font-size: 16px;
    }
    .rating{
        padding-top: 50px;
    padding-bottom: 50px;
    }
  

}

@media (max-width: 578px) {
    .rating{
    display: flex;
    align-items: center;
    justify-content: space-between; 
}

}
@media (max-width: 576px) {
    .box{
        width: 100%;
        margin-top: 30px;
    }
    .rating{
        padding-top: 30px;
    padding-bottom: 30px;
    }
}
`
